/* eslint-disable max-classes-per-file */
/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

export class SitterProfileServiceDropdownChanged extends AnalyticsEvent {
  eventName = 'sitter-profile-service-dropdown-changed';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;

  constructor(eventProperties: {
    serviceSlug: string;
    providerId: string;
    pageVariant?: 'revamp';
  }) {
    super(eventProperties);
  }
}

export class SitterProfileSeeAllRatesClicked extends AnalyticsEvent {
  eventName = 'sitter-profile-see-all-rates-clicked';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;

  constructor(eventProperties: { serviceSlug: string; pageVariant?: 'revamp' }) {
    super(eventProperties);
  }
}

export class SitterProfileEditProfilePressed extends AnalyticsEvent {
  eventName = 'sitter-profile-edit-profile-pressed';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;

  constructor(eventProperties: { pageVariant?: 'revamp' }) {
    super(eventProperties);
  }
}
